import { Calendar, Checkbox, DatePicker, Form, message, Modal, Tag } from "antd";
import dayjs from "dayjs";
import locale from "dayjs/locale/ru";
import { useState } from "react";
import "./records-copy.css";
import { serverFetch } from "../../server";
import { isMobile } from '@extensions/design';

// Настраиваем dayjs для использования русской локали с началом недели с понедельника
dayjs.locale(locale);

const RecordsCopy = ({ onClose, items }) => {
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [form] = Form.useForm();
  const [currentPanelValue, setCurrentPanelValue] = useState(dayjs());
  const [isPanelChanging, setIsPanelChanging] = useState(false);
  const [createLinkedChain, setCreateLinkedChain] = useState(true);
  const [copyClients, setCopyClients] = useState(false);

  const onSave = () => {
    setLoading(true);
    const data = {
      dates: dates.map(i => i.format("YYYY-MM-DD")),
      source: items,
      createLinkedChain: createLinkedChain,
      copyClients: copyClients,
    };
    serverFetch("Record/Paste", {method: "POST", bodyData: data})
      .then(() => {
        message.success("Запись успешно скопирована");
        onClose(true);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const onPanelChange = (value) => {
    // Отмечаем, что происходит смена панели
    setIsPanelChanging(true);
    setCurrentPanelValue(value);
    // Сбрасываем флаг через небольшую задержку
    setTimeout(() => setIsPanelChanging(false), 100);
  }

  const onSelect = value => {
    // Игнорируем вызовы onSelect во время смены панели (месяца/года)
    if (isPanelChanging) {
      return;
    }
    
    // Проверяем, что выбранная дата находится в текущем отображаемом месяце
    if (value.month() !== currentPanelValue.month() || value.year() !== currentPanelValue.year()) {
      return;
    }
    
    if (dates.find(i => i.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")))
      setDates([...dates.filter(i => i.format("DD-MM-YYYY") !== value.format("DD-MM-YYYY"))]);
    else
      setDates([...dates, value]);
  }

  const onRender = value => {
    const className = "records-copy" + (dates.find(i => i.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")) ? " records-copy-selected" : "");
    return<div className={className}>{value.format("D")}</div>
  }

  const divTags = dates.sort((a,b) => a-b).map(i => <Tag key={i}>{i.format("DD.MM.YY")}</Tag>)

  return <Modal title="Копирование записей" open
    onCancel={() => onClose(false)} onOk={onSave} okText="ОК" cancelText="Отмена"
    okButtonProps={{disabled: false}} loading={loading}
  >
    <Form form={form} colon={false}>
      <Form.Item>{divTags}</Form.Item>
      <Form.Item>
        <Calendar
          fullscreen={false}
          mode="month"
          onSelect={onSelect}
          onPanelChange={onPanelChange}
          disabledDate={date => date < dayjs().startOf('day')}
          fullCellRender={onRender}
          headerRender={({ value, onChange }) => (
            <div style={isMobile ? { marginTop: 16} : {marginBottom: 16, marginTop: 18}}>
              <DatePicker
                picker="month"
                value={value}
                onChange={(v) => { if (v) { onChange(v); onPanelChange(v); } }}
                allowClear={false}
                format="MMMM YYYY"
              />
            </div>
          )}
        />
      </Form.Item>
      <Form.Item>
        <Checkbox checked={createLinkedChain} onChange={(e) => setCreateLinkedChain(e.target.checked)}>
          Создать как связанную цепочку
        </Checkbox>
      </Form.Item>
      <Form.Item>
        <Checkbox checked={copyClients} onChange={(e) => setCopyClients(e.target.checked)}>
          Копировать клиентов записи
        </Checkbox>
      </Form.Item>
    </Form>
  </Modal>
}

export default RecordsCopy;